// extracted by mini-css-extract-plugin
export var labelWrapper = "_dy-0";